import { useTranslation } from "react-i18next";

interface OutreachFooterProps {
    companyName: string;
    privacyPolicies?: { url: string }[];
}

const OutreachFooter = ({ companyName, privacyPolicies }: OutreachFooterProps) => {
    const { t } = useTranslation();
    const privacyPolicyUrl = privacyPolicies?.[0]?.url;

    return (
        <div className="footer-area">
            <div className="outreach-footer-terms">
                {t("Outreach.Footer_WithdrawConsent")}
                {privacyPolicyUrl && (
                    <a href={privacyPolicyUrl} target="_blank" rel="noreferrer">
                        {companyName}
                        {t("Outreach.Footer_PrivacyPolicySuffix")}
                    </a>
                )}
                {privacyPolicyUrl && t("Outreach.Footer_And")}
                <a href="https://www.hubert.ai/candidate-privacy-policy" target="_blank" rel="noreferrer">
                    {t("Outreach.Footer_HubertPrivacyLink")}
                </a>
                .
            </div>
        </div>
    );
};

export default OutreachFooter;
